<template>
    <validation-observer v-slot="{ handleSubmit }" ref="formHandler">
        <form class="form tw-pb-4" @submit.prevent="handleSubmit(formSubmit)" novalidate>
            <div class="form-title tw-text-center tw-flex tw-flex-col tw-items-center tw-justify-center tw-font-bold tw-pt-0 lg:tw-pt-5 tw-pb-2">
                <p v-if="step === 1"><u>Vous avez un projet:</u></p>
                <p v-if="step === 2" class="tw-pb-3"><u>Mes données personnelles:</u></p>
            </div>
            <div class="step" v-if="step === 1 || !projet">
                <div class="tw-flex tw-items-center tw-gap-3 lg:tw-gap-16 tw-pb-4 tw-justify-around">
                    <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-text-center tw-cursor-pointer" :class="{ 'active' : projet == 'sol' }" @click="projet = 'sol';">
                        <img src="~@/assets/img/icons/grid-1.svg">
                        <p class="tw-font-bold tw-text-sm lg:tw-text-lg">Sols</p>
                        <small class="tw-block">parquet, vinyle, carrelage, moquette…</small>
                    </div>
                    <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-text-center tw-cursor-pointer" :class="{ 'active' : projet == 'murs' }" @click="projet = 'murs';">
                        <img src="~@/assets/img/icons/grid-2.svg">
                        <p class="tw-font-bold tw-text-sm lg:tw-text-lg">Murs</p>
                        <small class="tw-block">papier peint, peinture…</small>
                    </div>
                    <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-text-center tw-cursor-pointer" :class="{ 'active' : projet == 'fenetres' }" @click="projet = 'fenetres';">
                        <img src="~@/assets/img/icons/grid-3.svg">
                        <p class="tw-font-bold tw-text-sm lg:tw-text-lg">Fenêtres</p>
                        <small class="tw-block">stores, rideaux…</small>
                    </div>
                </div>
                <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-pb-5">
                    <small class="tw-block tw-text-xs tw-pb-1 tw-text-red-600" :class="{ 'tw-opacity-0' : !errorMessage || projet }">Veuillez sélectionner un projet</small>
                    <button class="btn-cta tw-w-full lg:tw-w-56" @click.prevent="checkForProjet">CONTINUER</button>
                </div>
            </div>
            <div class="step" v-if="step === 2">
                <fieldset class="tw-px-3 tw-pb-3 lg:tw-px-12 lg:tw-pb-5">
                    <div class="radios-container tw-flex tw-items-center tw-justify-start tw-pb-2">
                        <p class="tw-font-bold tw-pr-3">Civilité:</p>
                        <label class="tw-relative tw-cursor-pointer tw-mr-4" @click="civilite ='M'" :class="{'active' : civilite == 'M'}">
                            <span class="monsieur tw-text-xs lg:tw-text-sm">Monsieur</span>
                        </label>
                        <label class="tw-relative tw-cursor-pointer" @click="civilite ='Mme'" :class="{ 'active' : civilite == 'Mme'}" >
                            <span class="madame tw-text-xs lg:tw-text-sm">Madame</span>
                        </label>
                    </div>
                    <div class="tw-flex tw-flex-col lg:tw-flex-row tw-items-center tw-justify-center tw-gap-2 tw-pb-1 lg:tw-pb-0">
                        <validation-provider class="tw-w-full tw-w-block" name="lastName" rules="required|alpha_spaces" v-slot="{ classes }">
                            <div class="input-group input-group-name" :class="classes">
                                <input type="text"
                                    id="input-lastName"
                                    placeholder=" "
                                    v-model="lastName"
                                >
                                <label>
                                    Nom
                                </label>
                            </div>
                        </validation-provider>
                        <validation-provider class="tw-w-full tw-w-block" name="firstName" rules="required|alpha_spaces" v-slot="{ classes }">
                            <div class="input-group input-group-name" :class="classes">
                                <input type="text"
                                    id="input-firstName"
                                    placeholder=" "
                                    v-model="firstName"
                                >
                                <label>
                                    Prénom
                                </label>
                            </div>
                        </validation-provider>
                    </div>
                    <div class="tw-flex tw-flex-col lg:tw-flex-row tw-items-center tw-justify-center tw-gap-2">
                        <validation-provider class="tw-w-full tw-w-block" name="email" rules="required|email" v-slot="{ classes, errors }" :custom-messages="{ required: ' ', email: 'invalide' }">
                            <div class="input-group input-group-email" :class="classes">
                                <input type="email"
                                    id="input-email"
                                    placeholder=" "
                                    v-model.lazy="email"
                                >
                                <label>
                                    Email {{ errors [0]}}
                                </label>
                            </div>
                        </validation-provider>
                        <div class="tw-flex tw-flex-col tw-w-full lg:tw-flex-row tw-items-center tw-justify-center tw-gap-1 lg:tw-gap-2 tw-pb-1 lg:tw-pb-0">
                            <validation-provider class="tw-w-full tw-w-block" name="phone" rules="required|phone:fr" v-slot="{ classes }">
                                <div class="input-group input-group-phone" :class="classes">
                                    <input type="tel"
                                        id="input-phone"
                                        placeholder=" "
                                        v-model="phone"
                                        v-mask="{mask: '9999999999', placeholder:' '}"
                                    >
                                    <label>
                                        Téléphone portable
                                    </label>
                                </div>
                            </validation-provider>
                            <validation-provider class="tw-w-full tw-w-block" name="zip" rules="required" v-slot="{ classes }">
                                <div class="input-group input-group-zip" :class="classes">
                                    <input type="tel"
                                        id="input-zip"
                                        placeholder=" "
                                        v-model="zip"
                                        v-mask="{mask: '99999', placeholder:' '}"
                                    >
                                    <label>
                                        Postal Code
                                    </label>
                                </div>
                            </validation-provider>
                        </div>
                    </div>
                    <validation-provider class="tw-w-full tw-w-block" :rules="{required : { allowFalse: false } }" v-slot="{ classes }">
                        <div class="mb-2">
                            <div class="form-check p-0">
                                <label class="form-check-label" :class="classes">
                                    <input class="form-check-input" type="checkbox" value="true" v-model="$store.state.privacyPolicy">
                                    <span class="checkmark"></span>
                                    <span class="">J'autorise {{ company }} à utiliser mes données pour me contacter conformément à sa <a href="#" @click.prevent="$store.state.modal.terms = true;"><u>politique de confidentialité</u></a>.</span>
                                </label>
                            </div>
                        </div>
                        </validation-provider>
                        <div class="tw-text-center tw-mt-4 tw-mb-5 lg:tw-mb-0">
                            <button
                                type="submit"
                                class="btn-cta"
                                id="submit"
                                :disabled="formLoading"
                            >
                                MON ESTIMATION GRATUITE
                            </button>
                        </div>
                </fieldset>
            </div>

            <div class="steps tw-flex tw-items-center tw-justify-center tw-gap-2 tw-pb-5 lg:tw-pb-12">
                <div class="bullet" :class="{ 'active' : step >= 1 }"></div>
                <div class="bullet" :class="{ 'active' : step > 1 }"></div>
            </div>
        </form>
    </validation-observer>
</template>

<script>
import axios from 'axios';
// Check validations folder for more validations
import '@/validations';
import '@/validations/phone';

export default {
    name: 'FormComponent',
    data() {
        return {
            firstName: this.$route.query.firstName || '',
            lastName: this.$route.query.lastName || '',
            phone: this.$route.query.phone || '',
            email: this.$route.query.email || '',
            projet: this.$route.query.projet || '',
            zip: this.$route.query.zip || '',
            civilite: this.$route.query.civilite || '',
            pubid: this.$route.query.pubid || '',

            errorMessage: false,
            step: 1,
            formLoading: false,
            usedClasses: ['.has-error'],
            company: process.env.VUE_APP_COMPANY,
        };
    },
    methods: {
        checkForProjet() {
            if(!this.projet) {
                this.errorMessage = true;
            } else {
                this.errorMessage = false;
                this.step++;
            }
        },
        formSubmit() {
            if(!this.civilite) {
                document.querySelector('.monsieur').classList.add('has-error');
                document.querySelector('.madame').classList.add('has-error');
                this.formLoading = false;
                return false;
            } else {
                document.querySelector('.monsieur').classList.remove('has-error');
                document.querySelector('.madame').classList.remove('has-error');
            }

            this.formLoading = true;

            const action = `${process.env.VUE_APP_BACKOFFICE_ENDPOINT}/api/${process.env.VUE_APP_BACKOFFICE_SLUG}`;
            const data = {
                pubid: this.$route.query.pubid,
                utm_source: this.$route.query.utm_source,
                utm_campaign: this.$route.query.utm_campaign,
                utm_medium: this.$route.query.utm_medium,
                utm_content: this.$route.query.utm_content,
                utm_term: this.$route.query.utm_term,
                token: this.$store.state.token,

                firstName: this.firstName,
                lastName: this.lastName,
                phone: this.phone,
                email: this.email,
                zip: this.zip,
                civilite: this.civilite,
                projet: this.projet,
            };

            axios.post(action, data)
                .then((response) => {
                    this.$store.state.formSuccess = true;
                    this.$store.state.argann = response.data.argann;
                    this.$store.state.altid = response.data.altid;
                })
                .catch((error) => {
                    this.formLoading = false;
                    if (error.response.data.errors.email) {
                        error.response.data.errors.email = 'déjà enregistré';
                    }
                    console.log(error.response.data.errors);
                    this.$refs.formHandler.setErrors(error.response.data.errors);
                });
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/partials/_variables.scss';
</style>
